import React, { Component } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import "moment/locale/pt-br";
import MaskedInput from "react-maskedinput";
import { Table } from "reactstrap";
import { Container, Row, Col, FormGroup } from "reactstrap";
import indices from "./config/indices";
import salarioMinimo from "./config/salarioMinimo";
import { fonte } from "./config/indices";

import "react-datepicker/dist/react-datepicker.css";
import "./App.css";

class Justificativa extends Component {
  state = {
    data_ini: moment()
      .subtract(6, "months")
      .locale("pt-br"),
    data_fim: moment()
      .subtract(3, "months") // alterado de 3 para 0 (altera o mes final )
      .locale("pt-br"),
    resultado: "",
    valor_salario: "",
    per_salario: "",
    multa: "",
    decimoTerceiro: "0",
    parcelas: [],
    inpc: 1.23242453232,
    valor_final: "",
    subsequente: "0",
    salarioMinimo: [],
    tipoSalario: "0",
    decimoSalarios: []
  };

  calculaData = () => {
    if (this.state.per_salario === "") {
      alert("Insira o percentual a ser cobrado!");
    } else {
      this.state.parcelas = [];

      // Pega a data inicial e a data final
      let ini = moment(this.state.data_ini);
      let fim = moment(this.state.data_fim);

      // Pegar o valor ficticio do inpc
      let inpc = this.state.inpc;

      let valor_salario = parseFloat(this.state.valor_salario).toFixed(2);

      // Converte o valor do salário para float
      let per_salario =
        (parseFloat(this.state.per_salario) / 100) * valor_salario;

      // Calcula o valor do inpc vezes o valor do salário
      let valor = inpc * per_salario;

      // Calcula a quantidade de meses
      let resultado = fim.diff(ini, "months");
      let meses = parseInt(resultado) + 1;

      // Coloca o resultado no objeto resultado para ser exibido
      this.setState({ meses: meses });

      while (fim > ini || ini.format("M") === fim.format("M")) {
        let valorMes = parseInt(ini.format("MM")) - 1;
        let corrigido = indices[ini.format("YYYY")][valorMes];
        let minimo = salarioMinimo[ini.format("YYYY")][valorMes];

        let valor_salarioo =
          this.state.tipoSalario === "0"
            ? parseFloat(minimo).toFixed(2)
            : parseFloat(this.state.valor_salario).toFixed(2);

        // Converte o valor do salário para float
        let per_salarioo =
          (parseFloat(this.state.per_salario) / 100) * valor_salarioo;

        this.state.parcelas.push({
          mes: ini.format(),
          valor: 0,
          per_salario: per_salarioo.toFixed(2),
          comjuros: "",
          valor_pago: 0,
          indice_correcao: corrigido,
          valor_devido: 0,
          valor_final: 0,
          valor_correcao: 0,
          total: 0,
          valor_juros: 0,
          per_juros: 0,
          mes2: ini.format("MMM/YYYY"),
          minimo: minimo,
          numeroMes: valorMes,
          decimo: false,
          month: ini.format("MM")
        });

        if (this.state.decimoTerceiro === "1") {
          if (parseInt(ini.format("MM")) === 12) {
            this.state.parcelas.push({
              mes: ini.format(),
              valor: 0,
              per_salario: per_salarioo.toFixed(2),
              comjuros: "",
              valor_pago: 0,
              indice_correcao: corrigido,
              valor_devido: 0,
              valor_final: 0,
              valor_correcao: 0,
              total: 0,
              valor_juros: 0,
              per_juros: 0,
              mes2: ini.format("MMM/YYYY"),
              minimo: minimo,
              numeroMes: valorMes,
              decimo: true,
              month: ini.format("MM")
            });
          }
        }

        ini.add(1, "month");
        console.log(
          ini.format("MM-YYYY") + "  MESSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS"
        );
      }

      let counter = this.state.parcelas.length;
      console.log("Quantidade de meses: " + this.state.parcelas.length);
      for (var i = 0, a = 0, b = 0, c = 0, d = 0, e = 0; i < counter; i++) {
        // Valor corrigido
        a = parseFloat(a) + parseFloat(this.state.parcelas[i].valor);
        // Valor sem correção
        b = parseFloat(b) + parseFloat(this.state.parcelas[i].per_salario);

        console.log("Valor: " + this.state.parcelas[i].valor + " outro: " + a);

        // Pega o valor pago
        let valorPago = this.state.parcelas[i].valor_pago;

        // Pega o valor devido
        let valorDevido = this.state.parcelas[i].valor_devido;

        // Pega o valor da pensão
        let valorPensao =
          this.state.tipoSalario === "0"
            ? this.state.parcelas[i].per_salario
            : this.state.parcelas[i].per_salario;

        // Pega a data de hoje
        let hoje = moment();

        var mes = moment(this.state.parcelas[i].mes);

        var mesNumero = mes.format("MM");
        if (parseInt(mesNumero) === 12) {
          let result = fim.diff(mes, "months");
          var juros =
            this.state.subsequente === "0"
              ? parseInt(hoje.diff(mes, "months")) + 1
              : parseInt(hoje.diff(mes, "months"));

          this.state.parcelas[i].juros = parseInt(hoje.diff(mes, "months")) + 1;
        } else {
          let result = fim.diff(mes, "months");
          var juros =
            this.state.subsequente === "0"
              ? parseInt(hoje.diff(mes, "months")) + 1
              : parseInt(hoje.diff(mes, "months"));
          this.state.parcelas[i].juros = parseInt(hoje.diff(mes, "months")) + 1;
        }

        console.log(mesNumero + " " + "AAAAAAAAAAAAAAAAA");

        // Pega a diferença entre hoje e a data final
        let diffData = hoje.diff(fim, "months");

        // Converte o valor em inteiro e soma +1
        let diferencaData = parseInt(diffData) + 1;

        console.log("Diferença de datas: " + diferencaData);

        // This is where the magic happens kkk
        // Pega a quantidade de meses e diminui pelo index do array

        this.state.parcelas[i].per_juros = juros;

        // TOTAL
        let total = valorPensao - valorPago;
        this.state.parcelas[i].valor_devido = parseFloat(total.toFixed(2));

        // Valor da correção
        let correcao = this.state.parcelas[i].indice_correcao;

        this.state.parcelas[i].valor_correcao = correcao * total;

        this.state.parcelas[i].valor_juros =
          this.state.parcelas[i].valor_correcao * (juros / 100);

        this.state.parcelas[i].total =
          this.state.parcelas[i].valor_juros +
          this.state.parcelas[i].valor_correcao;

        // Diminui o valor pago do valor da pensão

        // Multiplica o valor corrigido pelo valor dos juros daquele mês
        let valorcomjuros =
          parseFloat(this.state.parcelas[i].per_salario) * (juros / 100);
        let valorjuros =
          parseFloat(this.state.parcelas[i].per_salario) * (juros / 100);

        console.log("Meses: " + counter);
        console.log("i = " + i);
        console.log("Iterator: " + juros);
        console.log("Valor dos juros: " + valorjuros);
        console.log("Juros + correção: " + valorcomjuros);
        console.log("SALARIO MINIMO É" + this.state.parcelas[i].minimo);
        console.log("MES: " + this.state.parcelas[i].mes);

        // Insere o valor corrigido acrescido de juros no objeto do array
        this.state.parcelas[i].comjuros =
          valorcomjuros + parseFloat(this.state.parcelas[i].valor);

        this.state.parcelas[i].valor_final =
          valorcomjuros + parseFloat(this.state.parcelas[i].valor);

        e = e + this.state.parcelas[i].total;
        this.state.valor_final = e;

        // this.state.parcelas[i].valor_final = this.state

        c = parseFloat(c) + parseFloat(this.state.parcelas[i].comjuros);
        d = this.state.multa / 100;
        let valormulta = d * c;
        var finalmulta = valormulta + c;
        console.log("NOVO VALOR TOTAL COM INPC E JUROS: " + c);
        console.log("NOVO VALOR COM MULTA " + finalmulta);
        console.log("-------------------------------------");
      }

      console.log(a);
      this.setState({
        total_inpc: a,
        total_sem_inpc: b,
        totalinpcejuros: c,
        totalinpcjurosmulta: finalmulta
      });
    }
  };

  mostraEstado = () => {
    console.log(this.state);
  };

  handleIni = e => {
    this.setState({ data_ini: e });
  };

  handleFim = e => {
    this.setState({ data_fim: e });
  };

  handlePerSalario = e => {
    let persalario = e.target.value;
    let parsed = persalario.replace(/,/g, ".");

    this.setState({ per_salario: parsed });
    console.log(parsed);
  };

  handleMulta = e => {
    this.setState({ multa: e.target.value });
  };

  handleValorSalario = e => {
    this.setState({ valor_salario: e.target.value });
  };

  handleValorPago = (e, index) => {
    const parcelas = this.state.parcelas;
    parcelas[e].valor_pago = index.target.value;
    parcelas[e].valor_final = parcelas[e].comjuros - parcelas[e].valor_pago;
    parcelas[e].valor_devido =
      this.state.tipoSalario === "0"
        ? parcelas[e].per_salario - parcelas[e].valor_pago
        : parcelas[e].per_salario - parcelas[e].valor_pago;
    parcelas[e].valor_correcao =
      parcelas[e].valor_devido * parcelas[e].indice_correcao;
    //console.log(e + ' ' + index)
    //console.log(parcelas[e].valor_pago)
    //

    let fim = moment(this.state.data_fim);
    let counter = this.state.parcelas.length;

    let hoje = moment();

    var mes = moment(this.state.parcelas[e].mes);

    var mesNumero = mes.format("MM");
    if (parseInt(mesNumero) === 12) {
      let result = fim.diff(mes, "months");
      var juros =
        this.state.subsequente === "0"
          ? parseInt(hoje.diff(mes, "months")) + 1
          : parseInt(hoje.diff(mes, "months"));

      this.state.parcelas[e].juros = parseInt(hoje.diff(mes, "months")) + 1;
    } else {
      let result = fim.diff(mes, "months");
      var juros =
        this.state.subsequente === "0"
          ? parseInt(hoje.diff(mes, "months")) + 1
          : parseInt(hoje.diff(mes, "months"));
      this.state.parcelas[e].juros = parseInt(hoje.diff(mes, "months")) + 1;
    }

    this.state.parcelas[e].per_juros = juros;

    parcelas[e].valor_juros = (juros / 100) * parcelas[e].valor_correcao;
    console.log("OVALORQUEQUERO VER " + (counter + 3 - e));
    parcelas[e].total = parcelas[e].valor_correcao + parcelas[e].valor_juros;

    for (var i = 0, a = 0; i < counter; i++) {
      a = parseFloat(a) + parseFloat(this.state.parcelas[i].total);
    }

    this.state.valor_final = a;

    this.forceUpdate();
  };

  handleSelect = event => {
    this.setState({ subsequente: event.target.value });
  };

  handleTipoSalario = event => {
    this.setState({ tipoSalario: event.target.value });
    this.calculaData();
  };

  handleDecimo = e => {
    this.setState({ decimoTerceiro: e.target.value });
  };

  validateInput = () => {
    let dataIni = this.state.data_ini;
    let dataFim = this.state.data_fim;
    let valorSalario = this.state.valor_salario;
    let perSalario = this.state.per_salario;
    if (dataIni && dataFim && valorSalario && perSalario) {
      return true;
    } else {
      return false;
    }
  };

  render() {
    const parcelas = [];

    return (
      <div className="App">
        <header>
          <img
            src={process.env.REACT_APP_LOGO_ESCURA}
            width="250"
            className="logodpe"
            alt="Logo da DPE/MT"
          />
          <h1 className="App-title">
            Calculadora de Pensão Alimentícia - Justificativa
          </h1>
        </header>
        <br />
        <br />
        <br />

        <div>
          <Container fluid className="inputs">
            <Row>
              <Col lg="4">
                <FormGroup>
                  <p className="text-left">Tipo de Rendimentos</p>
                  <select
                    className="form-control"
                    value={this.state.tipoSalario}
                    onChange={this.handleTipoSalario.bind(this)}
                  >
                    <option value="0">Salário Mínimo</option>
                    <option value="1">Rendimentos</option>
                  </select>
                </FormGroup>
              </Col>
              <Col lg="4">
                <FormGroup>
                  <p className="text-left">Mês Subsequente?</p>
                  <select
                    className="form-control"
                    value={this.state.subsequente}
                    onChange={this.handleSelect.bind(this)}
                  >
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                </FormGroup>
              </Col>
              <Col lg="4">
                <FormGroup>
                  <p className="text-left">Décimo Terceiro?</p>
                  <select
                    className="form-control"
                    value={this.state.decimoTerceiro}
                    onChange={this.handleDecimo.bind(this)}
                  >
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                </FormGroup>
              </Col>

              {this.state.tipoSalario === "0" ? (
                <p />
              ) : (
                <Col lg="4">
                  <FormGroup>
                    <p className="text-left">Valor dos Rendimentos</p>

                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text">R$</span>
                      </div>
                      <input
                        type="number"
                        className="form-control"
                        value={this.state.valor_salario}
                        onChange={this.handleValorSalario.bind(this)}
                        placeholder="Valor do Salário"
                      />
                      <div className="input-group-append" />
                    </div>
                  </FormGroup>
                </Col>
              )}
              {this.state.tipoSalario === "0" ? (
                <Col lg="7">
                  <p className="text-left">Percentual a ser cobrado</p>
                  <div className="input-group mb-3">
                    <div className="input-group-prepend" />
                    <input
                      placeholder="Percentual"
                      onChange={this.handlePerSalario.bind(this)}
                      className="form-control"
                    />
                    <div className="input-group-append">
                      <span className="input-group-text">%</span>
                    </div>
                  </div>
                </Col>
              ) : (
                <Col lg="4">
                  <p className="text-left">Percentual a ser cobrado</p>
                  <div className="input-group mb-3">
                    <div className="input-group-prepend" />
                    <input
                      mask="11"
                      placeholder="Percentual"
                      onChange={this.handlePerSalario.bind(this)}
                      className="form-control"
                    />
                    <div className="input-group-append">
                      <span className="input-group-text">%</span>
                    </div>
                  </div>
                </Col>
              )}

              <Col lg="6">
                <p className="text-left">Mês Inicial</p>
                <DatePicker
                  isClearable={true}
                  locale="pt-br"
                  dateFormat="DD/MM/YYYY"
                  className="form-control data-input"
                  selected={this.state.data_ini}
                  onChange={this.handleIni}
                  customInput={
                    <MaskedInput mask="11/11/1111" name="card" size="20" />
                  }
                />
              </Col>
              <Col lg="6">
                <p className="text-left">Mês Final</p>
                <DatePicker
                  locale="pt-br"
                  customInput={
                    <MaskedInput mask="11/11/1111" name="card" size="20" />
                  }
                  isClearable={true}
                  required
                  dateFormat="DD/MM/YYYY"
                  className="form-control data-input"
                  selected={this.state.data_fim}
                  onChange={this.handleFim}
                />
              </Col>
              <br />
              <Col lg="12" className="botao">
                <input
                  type="submit"
                  value="CALCULAR"
                  className="btn btn-block btn-primary"
                  onClick={this.calculaData.bind(this)}
                />
              </Col>
            </Row>
          </Container>
          <br />
          {this.state.parcelas.length === 0 ? (
            <p />
          ) : (
            <Container fluid>
              <Row>
                <Col lg="12">
                  <h5 className="text-left prestacoes">
                    Número de Prestações: {this.state.parcelas.length}{" "}
                  </h5>
                </Col>
                <Col lg="12">
                  <Table>
                    <thead>
                      <tr>
                        <th>Mês Referência</th>
                        <th>Data do Vencimento</th>
                        <th>Base do Cálculo</th>
                        <th>Percentual da Pensão</th>
                        <th>Valor da Pensão</th>
                        <th>Valor Pago</th>
                        <th>Valor Devido</th>
                        <th>Índice de Correção</th>
                        <th>Valor Corrigido (INPC)*</th>
                        <th>Juros**</th>
                        <th>Valor dos Juros</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.parcelas.map((parcela, index) => (
                        <tr>
                          <th scope="row" className="touper">
                            {parcela.decimo === true
                              ? "13º salário"
                              : parcela.mes2}
                          </th>
                          {this.state.subsequente === "0" ? (
                            <td className="touper">
                              {" "}
                              {moment(parcela.mes).format("MMM/YYYY")}
                            </td>
                          ) : (
                            <td className="touper">
                              {" "}
                              {moment(parcela.mes)
                                .add(1, "months")
                                .format("MMM/YYYY")}
                            </td>
                          )}
                          <td>
                            R${" "}
                            {this.state.tipoSalario === "0"
                              ? parseFloat(parcela.minimo).toFixed(2)
                              : parseFloat(this.state.valor_salario).toFixed(2)}
                          </td>
                          <td>{this.state.per_salario} %</td>
                          <td>
                            R${" "}
                            {this.state.tipoSalario === "0"
                              ? parcela.per_salario
                              : parcela.per_salario}
                          </td>
                          <td>
                            <p className="valor-pago__text">
                              R$ {parseFloat(parcela.valor_pago).toFixed(2)}
                            </p>
                            <div className="input-group valor-pago__input">
                              <div className="input-group-prepend">
                                <span className="input-group-text">R$</span>
                              </div>
                              <input
                                type="number"
                                onChange={this.handleValorPago.bind(
                                  this,
                                  index
                                )}
                                value={parcela.valor_pago}
                                className="form-control"
                                aria-label="Amount (to the nearest dollar)"
                              />
                              <div className="input-group-append" />
                            </div>
                          </td>
                          <td>R$ {parcela.valor_devido.toFixed(2)}</td>
                          <td>{parcela.indice_correcao}</td>
                          <td>R$ {parcela.valor_correcao.toFixed(2)}</td>
                          <td>{parcela.per_juros} %</td>
                          <td>R$ {parcela.valor_juros.toFixed(2)}</td>
                          <td>R$ {parcela.total.toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <h5 className="text-left">
                    TOTAL DA DÍVIDA: R$ {this.state.valor_final.toFixed(2)}
                  </h5>

                  <p className="text-left">
                    * Valores obtidos na tabela de fatores de atualização
                    monterária do site &nbsp;
                    {fonte}
                  </p>
                  <p className="text-left">** Juros de 1% ao mês.</p>
                </Col>
              </Row>
            </Container>
          )}
        </div>
      </div>
    );
  }
}

export default Justificativa;



// WEBPACK FOOTER //
// ./src/justificativa.jsx